import * as React from "react";
import { styled } from "@mui/material/styles";
import {
  Table, TableBody, TableContainer, TableHead, TableRow, Paper, Container, IconButton
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { Download, Link as LinkIcon } from "@mui/icons-material";

import { useState, useEffect } from "react";

import Config from "../config.json"; // Pastikan file ini ada
import { dateToStringDate } from "../Helpers"; // Pastikan fungsi ini ada

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function Proyek() {
  // State untuk bagian Events
  const url_list = Config.api_domain + "/proyek/active/";
  const [list, setList] = useState([]);
  const [search, setSearch] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(5);
  const [page, setPage] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(url_list, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) throw new Error("Server error");

        const data = await res.json();
        setList(data.data || []);
      } catch (error) {
        console.error("Fetch error:", error.message);
      }
    };

    fetchData();
  }, [url_list]);

  const filteredList = list.filter(item =>
    item.title.toLowerCase().includes(search.toLowerCase())
  );

  const paginatedList = filteredList.slice(
    page * entriesPerPage,
    (page + 1) * entriesPerPage
  );

  function getRows() {
    if (typeof list !== "undefined" && list !== null && list.length > 0) {
      return list.map((row, index) => {
        let dateISO = new Date(row.time_uploaded);
        let formatted_datetime = dateToStringDate(dateISO);
        return (
          <StyledTableRow key={row.public_id}>
            <StyledTableCell>{index + 1}</StyledTableCell>
            <StyledTableCell>{row.title}</StyledTableCell>
            <StyledTableCell>{formatted_datetime}</StyledTableCell>
            <StyledTableCell>
              <IconButton
                aria-label="download"
                component="a"
                href={Config.api_domain + "/proyek/download/" + row.public_id}
                download
              >
                <Download />
              </IconButton>
            </StyledTableCell>
          </StyledTableRow>
        );
      });
    } else {
      return (
        <StyledTableRow key="no-data">
          <StyledTableCell colSpan={4} align="center">
            No Data Found
          </StyledTableCell>
        </StyledTableRow>
      );
    }
  }

  return (
    <div style={{ padding: "1em 2em 3em 2em" }}>
      <Container>

        <h2>Project Management</h2>

        <h3>Project Description</h3>
        <p style={{ textAlign: "justify" }}>
          The objective of this consultancy is to provide a qualified Project Management Expert who will :
<br></br><br></br>a.  Enhance the quality of ILASP project planning.
<br></br>b.  Assist in team coordination, geospatial data management, and regulatory compliance.
<br></br>c.  Provide regular monitoring and evaluation reports.
        </p>

        {/* Unduh Section */}
        <h3>Announcement</h3>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 500 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>No</StyledTableCell>
                <StyledTableCell>Announcement</StyledTableCell>
                <StyledTableCell>Publication Date</StyledTableCell>
                <StyledTableCell>Download</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {getRows()}
            </TableBody>
          </Table>
        </TableContainer>

        <h3>Procurement Timeline</h3>
<TableContainer component={Paper} sx={{ mb: 6 }}>
  <Table sx={{ minWidth: 800 }} aria-label="timeline table">
    <TableHead>
      <TableRow>
        <StyledTableCell>No.</StyledTableCell>
        <StyledTableCell>Activity</StyledTableCell>
        <StyledTableCell>Start Date</StyledTableCell>
        <StyledTableCell>End Date</StyledTableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      <StyledTableRow>
        <StyledTableCell>1</StyledTableCell>
        <StyledTableCell>Publication of the REoI, TOR & Timeline (website ILASPP) + LPSE</StyledTableCell>
        <StyledTableCell>08 September 2025, 16:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>19 September 2025, 16:00 (GMT+7)</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>2</StyledTableCell>
        <StyledTableCell>Clarification and addenda to the REoI and TOR</StyledTableCell>
        <StyledTableCell>10 September 2025, 09:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>11 September 2025, 12:00 (GMT+7)</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>3</StyledTableCell>
        <StyledTableCell>Submission of expressions of Interests (EoI)</StyledTableCell>
        <StyledTableCell>08 September 2025, 16:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>19 September 2025, 16:00 (GMT+7)</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>4</StyledTableCell>
        <StyledTableCell>Evaluation of Expression of Interest</StyledTableCell>
        <StyledTableCell>22 September 2025, 09:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>24 September 2025, 16:00 (GMT+7)</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>5</StyledTableCell>
        <StyledTableCell>Interview & Evaluation Results</StyledTableCell>
        <StyledTableCell>25 September 2025, 09:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>01 October 2025, 15:00 (GMT+7)</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>6</StyledTableCell>
        <StyledTableCell>Notification of Intention to Award</StyledTableCell>
        <StyledTableCell>02 October 2025, 09:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>02 October 2025, 16:00 (GMT+7)</StyledTableCell>
      </StyledTableRow>


    </TableBody>
  </Table>
</TableContainer>

<p>Clarifications and Addenda to the REoI and TOR and Submission of Expressions of Interest (EOI) may be submitted via email to : <a
    href="mailto:proyek.ilasp@big.go.id"
    style={{ color: "#1976d2", textDecoration: "underline" }}
  >proyek.ilasp@big.go.id</a></p>
      </Container>
    </div>
  );
}

export default Proyek;
